import { ChartDataIntervals } from 'app/shared/model/charts/chart-data-intervals.enum';

export const ChartDataIntervalOptions = {
  [ChartDataIntervals.Day]: { label: 'Daily', value: ChartDataIntervals.Day },
  [ChartDataIntervals.Week]: { label: 'Weekly', value: ChartDataIntervals.Week },
  [ChartDataIntervals.Month]: { label: 'Monthly', value: ChartDataIntervals.Month },
  [ChartDataIntervals.Quarter]: { label: 'Quarterly', value: ChartDataIntervals.Quarter },
};
